import {
  Component,
  ChangeDetectionStrategy,
  inject,
  input,
} from '@angular/core';
import { CardComponent } from 'src/app/ui-kit/card/card/card.component';
import { IconComponent } from 'src/app/ui-kit/icon/icon.component';
import { NavController } from '@ionic/angular/standalone';
import { ButtonComponent } from 'src/app/ui-kit/button/button.component';

/**
 * Empty state component for displaying when a user lacks permissions.
 * 
 * Displays a lock icon with a message indicating the user doesn't have
 * permission to access the feature.
 * 
 * @example
 * ```html
 * <app-no-permission-block />
 * ```
 * 
 * @example With custom message
 * ```html
 * <app-no-permission-block [message]="'You do not have permission to delete users'" />
 * ```
 */
@Component({
  selector: 'app-no-permission-block',
  templateUrl: './no-permission-block.component.html',
  styleUrls: ['./no-permission-block.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CardComponent, IconComponent, ButtonComponent],
  host: {
    class: 'block',
  },
})
export class NoPermissionBlockComponent {
  private readonly navController = inject(NavController);

  /**
   * Custom message to display. Defaults to standard permission message.
   */
  message = input<string>('You do not have permission to access this feature');

  /**
   * Icon name to display. Defaults to lock icon.
   */
  icon = input<string>('lock-closed-outline');

  /**
   * Icon size. Defaults to '4xl' for emphasis.
   */
  iconSize = input<'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl'>('lg');

  /**
   * Navigate to home.
   */
  navigateToHome() {
    this.navController.navigateBack('/my-blume');
  }
}

